package app.nestbridge.feature.careteam.service

import app.nestbridge.domain.identity.api.model.ProfessionalServiceTypeDto
import app.nestbridge.domain.identity.model.ProfessionalServiceType
import app.nestbridge.feature.careteam.api.model.CareTeamDto
import app.nestbridge.feature.careteam.api.model.CareTeamMemberDto
import app.nestbridge.feature.careteam.api.model.TeamRelationshipRoleDto
import app.nestbridge.feature.careteam.model.CareTeam
import app.nestbridge.feature.careteam.model.CareTeamMember
import app.nestbridge.feature.careteam.model.TeamRelationshipRole

internal fun CareTeamDto.toDomain(): CareTeam = CareTeam(
    id = id,
    childId = childId,
    teamType = teamType.toDomainProfessional(),
    description = description,
    members = members.map { it.toDomain() },
    status = status,
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun CareTeam.toDto(): CareTeamDto = CareTeamDto(
    id = id,
    childId = childId,
    teamType = teamType.toDtoProfessional(),
    description = description,
    members = members.map { it.toDto() },
    status = status,
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun CareTeamMemberDto.toDomain(): CareTeamMember = CareTeamMember(
    userId = userId,
    role = role.toDomain(),
)

internal fun CareTeamMember.toDto(): CareTeamMemberDto = CareTeamMemberDto(
    userId = userId,
    role = role.toDto(),
)

internal fun TeamRelationshipRoleDto.toDomain(): TeamRelationshipRole = when (this) {
    TeamRelationshipRoleDto.ORGANIZER -> TeamRelationshipRole.ORGANIZER
    TeamRelationshipRoleDto.THERAPIST -> TeamRelationshipRole.THERAPIST
    TeamRelationshipRoleDto.PARENT -> TeamRelationshipRole.PARENT
    TeamRelationshipRoleDto.OBSERVER -> TeamRelationshipRole.OBSERVER
}

internal fun TeamRelationshipRole.toDto(): TeamRelationshipRoleDto = when (this) {
    TeamRelationshipRole.ORGANIZER -> TeamRelationshipRoleDto.ORGANIZER
    TeamRelationshipRole.THERAPIST -> TeamRelationshipRoleDto.THERAPIST
    TeamRelationshipRole.PARENT -> TeamRelationshipRoleDto.PARENT
    TeamRelationshipRole.OBSERVER -> TeamRelationshipRoleDto.OBSERVER
}

private fun ProfessionalServiceTypeDto.toDomainProfessional(): ProfessionalServiceType = when (this) {
    ProfessionalServiceTypeDto.SpeechLanguageTherapy -> ProfessionalServiceType.SpeechLanguageTherapy
    ProfessionalServiceTypeDto.OccupationalTherapy -> ProfessionalServiceType.OccupationalTherapy
    ProfessionalServiceTypeDto.PhysicalTherapy -> ProfessionalServiceType.PhysicalTherapy
    ProfessionalServiceTypeDto.DevelopmentalTherapy -> ProfessionalServiceType.DevelopmentalTherapy
    ProfessionalServiceTypeDto.AppliedBehaviorAnalysis -> ProfessionalServiceType.AppliedBehaviorAnalysis
    ProfessionalServiceTypeDto.FeedingTherapy -> ProfessionalServiceType.FeedingTherapy
    ProfessionalServiceTypeDto.MentalHealthCounseling -> ProfessionalServiceType.MentalHealthCounseling
    ProfessionalServiceTypeDto.Psychology -> ProfessionalServiceType.Psychology
    ProfessionalServiceTypeDto.SocialWork -> ProfessionalServiceType.SocialWork
    ProfessionalServiceTypeDto.EarlyChildhoodEducation -> ProfessionalServiceType.EarlyChildhoodEducation
    ProfessionalServiceTypeDto.VisionServices -> ProfessionalServiceType.VisionServices
    ProfessionalServiceTypeDto.HearingAudiology -> ProfessionalServiceType.HearingAudiology
    ProfessionalServiceTypeDto.Other -> ProfessionalServiceType.Other
}

private fun ProfessionalServiceType.toDtoProfessional(): ProfessionalServiceTypeDto = when (this) {
    ProfessionalServiceType.SpeechLanguageTherapy -> ProfessionalServiceTypeDto.SpeechLanguageTherapy
    ProfessionalServiceType.OccupationalTherapy -> ProfessionalServiceTypeDto.OccupationalTherapy
    ProfessionalServiceType.PhysicalTherapy -> ProfessionalServiceTypeDto.PhysicalTherapy
    ProfessionalServiceType.DevelopmentalTherapy -> ProfessionalServiceTypeDto.DevelopmentalTherapy
    ProfessionalServiceType.AppliedBehaviorAnalysis -> ProfessionalServiceTypeDto.AppliedBehaviorAnalysis
    ProfessionalServiceType.FeedingTherapy -> ProfessionalServiceTypeDto.FeedingTherapy
    ProfessionalServiceType.MentalHealthCounseling -> ProfessionalServiceTypeDto.MentalHealthCounseling
    ProfessionalServiceType.Psychology -> ProfessionalServiceTypeDto.Psychology
    ProfessionalServiceType.SocialWork -> ProfessionalServiceTypeDto.SocialWork
    ProfessionalServiceType.EarlyChildhoodEducation -> ProfessionalServiceTypeDto.EarlyChildhoodEducation
    ProfessionalServiceType.VisionServices -> ProfessionalServiceTypeDto.VisionServices
    ProfessionalServiceType.HearingAudiology -> ProfessionalServiceTypeDto.HearingAudiology
    ProfessionalServiceType.Other -> ProfessionalServiceTypeDto.Other
}
